module.exports = __webpack_public_path__ + "static/media/ziqita.5e439c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/ziqita.png
// module id = 2189
// module chunks = 0